import React from "react";
import api from "../../api/resources";

const initialData = {
  deleteModalOpen: false,
  resourceInfo: null,
  deletedResource: null,
  isUpdatingResource: false,
  updatedResource: null,
  isEdited: true,
};

export default function useResourceEdit() {
  const [resourceData, setResourcesData_] = React.useState(initialData);

  const setResourcesData = newData => {
    const newResourcesData = {
      ...resourceData,
      ...newData
    };

    setResourcesData_(newResourcesData);
  };

  function updateResource(id, data) {
    setResourcesData({ isUpdatingResource: true });

    api.updateResource(id, data).then(({ data }) => {
      setResourcesData({ updatedResource: data, isUpdatingResource: false });
    });
  }

  function deleteResource(id) {
    api.deleteResource(id).then(({ data }) => {
      setResourcesData({ deletedResource: data });
    });
  }

  function getResource(id) {
    api.getResource(id)
    .then((resourceInfo) => {
      setResourcesData({
        resourceInfo: {
          data: resourceInfo.data.data,
          info: resourceInfo.data.info,
        }
      });
    });
  }

  return { resourceData, setResourcesData, updateResource, deleteResource, getResource };
}
